import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '2832673310418578';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: unknown;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || window.fbq) return;
    try {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // Swallow load failures (ad blockers / sandboxed previews) so the app never crashes.
      t.onerror = () => {};
      const target = document.getElementsByTagName('script')[0] || document.head || document.body;
      if (target && target.parentNode) {
        target.parentNode.insertBefore(t, target);
      } else {
        document.head.appendChild(t);
      }
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (e) {
      // Never let pixel setup break the page.
      // eslint-disable-next-line no-console
      console.warn('Meta Pixel init skipped:', e);
    }
  }, []);
  return <noscript data-id="element-96">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-97" />
    </noscript>;
}